function init() {
	
	var $totalPrice = $('.js-total-price'),
		$quantity = $('.js-product-qty'),
		$subTotal = $('.js-sub-total'),
		$purchaseForm = $('.js-product-form');
	
	if (!$quantity) {
		return;
	}
	
	$quantity.on('change', function(event) {
		event.preventDefault();
		let newValue;

		// if the value is less than 1, set it to 1, and adjust the price total.
		if(event.target.value < 1) {
			newValue = 1;
		} else {
			// if the value is greater than one and if the quantity is provided in decimals, round it.
			newValue = Math.round(event.target.value);
		}

		$quantity.val(newValue);

		$subTotal.html(newValue * $totalPrice.val());
	});
	
	$purchaseForm.on('submit', function(event) {
		event.preventDefault();
	});
	
}

export default init;